var App = App || {};

(function (ns, $, undefined) {

    /**
   * @param  {string css selector} toggleTrigger: the element which initiates the behavior
   * @param  {string css selector} toggleTarget: the element that the behavior acts upon  
   * @return {none}
   */
    ns.callSlideToggle = function (trigger, target) {
        var $trigger = $(trigger);
        var $target = $(target);

        $trigger.on('click', function () {
            $target.slideToggle();
        });
    };

    ns.closeToggleOnDocumentClick = function () {
        $(document.body).on('click', function (e) {
            if ($(e.target).closest('.js-history-dropdown-wrap').length === 0) {
                $('.js-history-entries-wrap:visible').slideToggle();
            }
        });
    };

    $(document).ready(function () {
        ns.init();
    });

    ns.init = function () {
        ns.callSlideToggle('.pub-history__label', '.pub-history__wrap');
        ns.closeToggleOnDocumentClick();
    };

})(App.CustomScript = App.CustomScript || {}, jQuery);